var map = {
	"./aperture.svg": "c5c8",
	"./check-square.svg": "0d55",
	"./classroom-header.svg": "a751",
	"./edit.svg": "39ff",
	"./eye.svg": "05e3",
	"./group-chat.svg": "fb0e",
	"./mic.svg": "7cc2",
	"./monitor.svg": "195c",
	"./play-circle.svg": "0999",
	"./smile.svg": "d314",
	"./trello.svg": "50bf",
	"./users.svg": "f1f2",
	"./video.svg": "161f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1999";